import { render, staticRenderFns } from "./TagIndex.vue?vue&type=template&id=ab850ca8&"
import script from "./TagIndex.vue?vue&type=script&lang=js&"
export * from "./TagIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports